var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 12C2.05228 12 2.49482 12.4488 2.54995 12.9984C2.713 14.6234 3.2723 16.1893 4.1853 17.5557C5.28412 19.2002 6.8459 20.4819 8.67317 21.2388C10.5004 21.9957 12.5111 22.1937 14.4509 21.8078C16.3907 21.422 18.1725 20.4696 19.5711 19.0711C20.9696 17.6725 21.922 15.8907 22.3079 13.9509C22.6937 12.0111 22.4957 10.0004 21.7388 8.17316C20.9819 6.3459 19.7002 4.78411 18.0557 3.6853C16.6893 2.7723 15.1234 2.213 13.4984 2.04995C12.9488 1.99481 12.5 1.55228 12.5 0.999994C12.5 0.44771 12.9485 -0.00433525 13.4989 0.0416338C15.5201 0.210449 17.4714 0.889504 19.1668 2.02236C21.1402 3.34094 22.6783 5.21508 23.5866 7.40779C24.4948 9.60051 24.7324 12.0133 24.2694 14.3411C23.8064 16.6689 22.6635 18.807 20.9853 20.4853C19.3071 22.1635 17.1689 23.3064 14.8411 23.7694C12.5133 24.2324 10.1005 23.9948 7.9078 23.0865C5.71509 22.1783 3.84094 20.6402 2.52236 18.6668C1.38951 16.9714 0.710455 15.0201 0.541639 12.9989C0.49567 12.4485 0.947715 12 1.5 12Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.8ae719c5.svg";
export { ForwardRef as ReactComponent };